import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { VideoEasyComponent } from './video-easy.component';

@NgModule({
    declarations: [
        VideoEasyComponent
    ],
    imports: [
        CommonModule
    ],
    exports: [
        VideoEasyComponent
    ]
})
export class NcVideoEasyModule { }